module.exports = __webpack_public_path__ + "img/gallery-5.bc791b44.jpg";